import { generateUtilityClasses } from '@mui/material';

export const menuContainerToolbarClasses = generateUtilityClasses('MenuContainerToolbar', [
  'root',
  'text',
  'checkboxItem',
  'switch',
]);
